import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent, IPermission, PermissionType, RolePermissionService, UtilitiesService } from 'lib-core-shared';
import { of, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

const CONFIRMATION_UNSAVED_CHANGES: string ='';
@Component({
  selector: 'lib-auth-links',
  templateUrl: './auth-links.component.html',
  styleUrls: ['./auth-links.component.css']
})
export class AuthLinksComponent implements OnInit {
  public loginDisplay: boolean = false;
  public firstName: string | undefined = undefined;
  private readonly _destroying$ = new Subject<void>();
  // public environment = this.env;

  mobileMenus: any = {
    nav: {
      open: false
    },
    region: {
      open: false
    },
    vehicle: {
      open: false
    }
  }

  constructor(
    private readonly rolePermissionService: RolePermissionService,
    private modalService: NgbModal,
    private utiliseService: UtilitiesService,
    public router: Router,
    public routerActivate: ActivatedRoute,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    // @Inject(ENVIRONMENT) private env: Environment
  ) {}

  ngOnInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
    )
    .subscribe((result: EventMessage) => {
      this.setLoginDisplay();
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe((r) => {
        this.setLoginDisplay();
      })
  }

  profile() {
    const gotoProfile = () => {
      this.router.navigate(['profile'], { relativeTo: this.routerActivate});
    };

    this.unSavedChangeConfirmation(gotoProfile);
  }

  login() {
    this.authService.loginPopup()
      .subscribe({
        next: (result) => {
          this.setLoginDisplay();
        },
        error: (error) => console.log(error)
      });
  }

  logout() { 
    const logoutPopup = () => {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    };

    this.unSavedChangeConfirmation(logoutPopup);
  }

  private unSavedChangeConfirmation(callBack: any): void {
    if (this.utiliseService.unSavedChangesConfirm) {
      const modalRef = this.modalService.open(ConfirmationModalComponent);
      modalRef.componentInstance.title = 'Confirmation';
      modalRef.componentInstance.body = CONFIRMATION_UNSAVED_CHANGES;
      modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
          if (!outcome) {
              this.utiliseService.setFocusToCurrentInput = of(true);
              modalRef.close();
          } else {
            this.utiliseService.unSavedChangesConfirm = false;
            modalRef.close();
            callBack();
          }
      });
    } else {
      callBack();
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    try {
      let accountInfo = this.authService.instance.getAllAccounts()[0];
      RolePermissionService.userRole = {
        id: 0,
        name: '',
        permissions:[]
      };
      accountInfo?.idTokenClaims?.roles?.forEach(role => {
        const permission: IPermission = {} as IPermission;
        permission.id = RolePermissionService.userRole.permissions.length + 1;
        if (role.toLowerCase().indexOf('create') > -1) {
          permission.value = PermissionType.create;
        }

        if (role.toLowerCase().indexOf('update') > -1) {
          permission.value = PermissionType.update;
        }

        if (role.toLowerCase().indexOf('delete') > -1) {
          permission.value = PermissionType.delete;
        }

        if (role.toLowerCase().indexOf('read') > -1) {
          permission.value = PermissionType.read;
        }
        permission.name = role;
        RolePermissionService.userRole.name = accountInfo.username;
        RolePermissionService.userRole.permissions.push(permission);
      });
      const res = RolePermissionService.userRole.permissions;
      const testCount = RolePermissionService.userRole.permissions.length;
      this.firstName = accountInfo?.name?.split(" ")[0];
    }
    catch {
      this.firstName = '';
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
